var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 30,
    viewBox: "0 0 34 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 30,
    rx: 5,
    fill: "#2A86FF",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 13.3333V19.6889C22 20.4978 22 20.9024 21.8443 21.2113C21.7074 21.4831 21.4888 21.7041 21.22 21.8426C20.9144 22 20.5144 22 19.7143 22H14.2857C13.4856 22 13.0856 22 12.78 21.8426C12.5112 21.7041 12.2927 21.4831 12.1557 21.2113C12 20.9024 12 20.4978 12 19.6889V11.3111C12 10.5021 12 10.0977 12.1557 9.78868C12.2927 9.51689 12.5112 9.29592 12.78 9.15744C13.0856 9 13.4856 9 14.2857 9H17.7143M22 13.3333L17.7143 9M22 13.3333H18.4286C18.0341 13.3333 17.7143 13.01 17.7143 12.6111V9",
    stroke: "#2A86FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileIcon);
export default __webpack_public_path__ + "static/media/fileIcon.a96f5fbd16afba6c805ecd5b4be94a15.svg";
export { ForwardRef as ReactComponent };